import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import { useLocation } from 'react-router-dom';
import echo from '../../../../config/echo';
import { ArrowLeft, Send, Play } from 'lucide-react';

import "../../../../assets/css/screens/customer/dashboard/inbox/CustomerChat.css";
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';

const CustomerChat = () => {
  const { baseUrl, authToken, baseUrlForFile } = useContext(AppContext);
  const { conversationId } = useParams();
  const location = useLocation();
  const ticketDescription = location.state?.description;
  const navigate = useNavigate();

  const [ticket, setTicket] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);

  const [customerMedia, setCustomerMedia] = useState([]);
  const [workerProofs, setWorkerProofs] = useState([]);
  const [sending, setSending] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);

  const [messages, setMessages] = useState([]);
  const [type, setType] = useState('');

  const bottomRef = useRef(null);
  const [isResolved, setIsResolved] = useState(false);

  // =========================
  // SEND MESSAGE
  // =========================
  const sendMessage = async () => {
    if (sending) return; // Already sending

    if (isResolved) {
      alert("This ticket has been resolved.");
      return;
    }

    if (!type.trim() || !conversationId) return;

    setSending(true);

    const formData = new FormData();
    formData.append("whconversation_id", Number(conversationId));
    formData.append("message", type.trim());
    formData.append("sender", "customer");
    formData.append("type", "text");

    try {
      const response = await axios.post(
        `${baseUrl}/customer/chat`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setType("");
    } catch (err) {
      console.log("ERROR:", err.response?.data || err.message);
    } finally {
      setSending(false);
    }
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !sending) {
      sendMessage();
    }
  };

  // =========================
  // LOAD CHATS
  // =========================

  useEffect(() => {
    if (!conversationId) return;

    const auth = authToken || localStorage.getItem('authToken');

    axios.get(`${baseUrl}/customer/viewchat`, {
      headers: { Authorization: `Bearer ${auth}` },
      params: { whconversation_id: conversationId }
    })
      .then(res => {
        const chats = res.data.chats || [];
        console.log("CHAT RESPONSE:", res.data);

        // const ticketMsg = ticketDescription
        //   ? [{
        //       id: 'ticket-desc',
        //       sender: 'system',
        //       message: `🟡 Ticket: ${ticketDescription}`
        //     }]
        //   : [];

        setMessages(chats);

        setCustomerMedia(res.data.customerMedia || []);
        setWorkerProofs(res.data.workerProofs || []);
        setIsResolved(res.data.status === "resolved");
      })
      .catch(err => {
        console.log(err.response?.data || err.message);
      });

  }, [conversationId]);
  const hasMedia =
    customerMedia?.length > 0 ||
    workerProofs?.length > 0;
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);
 useEffect(() => {

  if (!conversationId) return;

  console.log("Joining Conversation:", `conversation-${conversationId}`);

  const channel = echo.channel(`conversation-${conversationId}`);

  channel.subscribed(() => {
    console.log("Conversation Joined");
  });

  channel.listen(".ChatMessageSent", (event) => {

    console.log("Socket Event:", event);

    // ✅ Admin ne ticket resolve kar diya
    if (event.status === "resolved") {
      setIsResolved(true);
      return;
    }

    // ✅ Agar message nahi hai to kuch mat karo
    if (!event.chat) return;

    setMessages(prev => {

      // Duplicate message add na ho
      if (prev.some(msg => msg.id === event.chat.id)) {
        return prev;
      }

      return [...prev, event.chat];
    });

  });

  return () => {

    console.log("Leaving Conversation");

    echo.leave(`conversation-${conversationId}`);

  };

}, [conversationId]);
  return (
    <>
      {/* <AppNavbar /> */}

      <div className="cc-root">

        {/* HEADER */}
        <div className="cc-header">
          <button onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>
          <h3>Chat</h3>
        </div>

        {/* IMAGE MODAL */}
        {previewImage && (
          <div className="cc-media-modal" onClick={() => setPreviewImage(null)}>
            <button className="cc-media-close" onClick={() => setPreviewImage(null)}>✖</button>
            <img src={previewImage} alt="preview" />
          </div>
        )}

        {/* VIDEO MODAL */}
        {previewVideo && (
          <div className="cc-media-modal" onClick={() => setPreviewVideo(null)}>
            <button className="cc-media-close" onClick={() => setPreviewVideo(null)}>✖</button>
            <video controls autoPlay>
              <source src={previewVideo} />
            </video>
          </div>
        )}

        {/* MESSAGES */}
        <div className="cc-messages">
          {ticketDescription && (
            <div className="cc-ticket-box">
              🟡 Ticket: {ticketDescription}
            </div>
          )}

          {/* MEDIA SECTION */}
          {hasMedia && (
            <div className="cc-dispute-media">

              {customerMedia.length > 0 && (
                <>
                  <h5>Customer Media</h5>
                  <div className="cc-media-grid">
                    {customerMedia.map((media) => {
                      const ext = media.file?.split('.').pop()?.toLowerCase();
                      const isVideo = ["mp4", "webm", "mov", "avi"].includes(ext);

                      return isVideo ? (
                        <div
                          key={media.id}
                          className="cc-video-thumb"
                          onClick={() =>
                            setPreviewVideo(`${baseUrlForFile}/${media.file}`)
                          }
                        >
                          <video
                            src={`${baseUrlForFile}/${media.file}`}
                            muted
                          />
                          <div className="cc-video-play">
                            <Play size={28} fill="white" />
                          </div>
                        </div>
                      ) : (
                        <img
                          key={media.id}
                          src={`${baseUrlForFile}/${media.file}`}
                          onClick={() =>
                            setPreviewImage(`${baseUrlForFile}/${media.file}`)
                          }
                        />
                      );
                    })}
                  </div>
                </>
              )}

              {workerProofs.length > 0 && (
                <>
                  <h5>Worker Proofs</h5>
                  <div className="cc-media-grid">
                    {workerProofs.map((media) => {
                      const ext = media.file?.split('.').pop()?.toLowerCase();
                      const isVideo = ["mp4", "webm", "mov", "avi"].includes(ext);

                      return isVideo ? (
                        <div
                          key={media.id}
                          className="cc-video-thumb"
                          onClick={() =>
                            setPreviewVideo(`${baseUrlForFile}/${media.file}`)
                          }
                        >
                          <video
                            src={`${baseUrlForFile}/${media.file}`}
                            muted
                          />
                          <div className="cc-video-play">
                            <Play size={28} fill="white" />
                          </div>
                        </div>
                      ) : (
                        <img
                          key={media.id}
                          src={`${baseUrlForFile}/${media.file}`}
                          onClick={() =>
                            setPreviewImage(`${baseUrlForFile}/${media.file}`)
                          }
                        />
                      );
                    })}
                  </div>
                </>
              )}

            </div>
          )}

          {/* CHAT MESSAGES */}
          {messages.map((msg, i) => (
            <div
              key={msg.id || i}
              className={
                msg.sender === "customer"
                  ? "cc-bubble cc-mine"
                  : msg.sender === "system"
                    ? "cc-bubble cc-system"
                    : msg.sender === "admin"
                      ? "cc-bubble cc-admin"
                      : "cc-bubble cc-worker"
              }
            >
              {msg.sender !== "system" && (
                <small className="cc-sender">
                  {msg.sender === "customer"
                    ? "You"
                    : msg.sender === "admin"
                      ? "Admin"
                      : "Worker"}
                </small>
              )}

              <p>{msg.message}</p>
            </div>
          ))}

          <div ref={bottomRef} />
        </div>

        {/* INPUT */}
        {!isResolved ? (
          <div className="cc-input">
            <input
              value={type}
              onChange={(e) => setType(e.target.value)}
              onKeyDown={handleKey}
              placeholder="Type message..."
            />

            <button
              onClick={sendMessage}
              disabled={sending}
            >
              <Send size={18} />
            </button>
          </div>
        ) : (
          <div className="wc-ticket-resolved">
            <span className="wc-ticket-resolved__badge">
              ✅ This ticket has been resolved. Chat is closed.
            </span>
          </div>
        )}

      </div>
    </>
  );
};

export default CustomerChat;